/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class Table extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    state = {
        blank: [['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--']],
    };

    render() {
        const { isOpen } = this.props;
        const { name, tit, data, url, key } = this.props.content;
        const { blank } = this.state;
        const renderColor = (item, index, key) => {
            if (index === 1 && (key === 'zjlcstock' || key === 'zjlchy')) {
                return styles.green;
            } else if (item && index === 2) {
                const num = item.slice(0, item.length - 1) * 1;

                if (num < 0) {
                    return styles.green;
                } else if (num === 0) {
                    return styles.black;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        };

        return (
            <div className={styles.table}>
                <h3>
                    <a href={name && name.url} rel={rel} target="_blank">
                        {name && name.name}
                    </a>
                </h3>
                <table border="0">
                    <tbody>
                        <tr>
                            {tit && tit.length > 0 && tit.map && tit.map((item, index) => <th key={index}>{item}</th>)}
                        </tr>
                        {data && data.length > 0 && data.map
                            ? data.map((item, index) => (
                                  <tr key={index}>
                                      {item.map((_item, _index) => {
                                          if (_index === 0 && _item) {
                                              return (
                                                  <td key={_index}>
                                                      {typeof _item === 'string' ? (
                                                          _item
                                                      ) : _item.name ? (
                                                          <a
                                                              href={_item.url}
                                                              rel={rel}
                                                              target="_blank"
                                                              title={
                                                                  key === 'zjlrhy' || key === 'zjlchy' ? _item.name : ''
                                                              }>
                                                              {_item.name}
                                                          </a>
                                                      ) : (
                                                          <span style={{ color: '#273766' }}>--</span>
                                                      )}
                                                  </td>
                                              );
                                          } else {
                                              return (
                                                  <td key={_index} className={renderColor(_item, _index, key)}>
                                                      {/* className={
                                                          (_index === 1 && (key === 'zjlcstock' || key === 'zjlchy')) ||
                                                          (_index === 2 && _item.slice(0, _item.length - 1) * 1 < 0)
                                                              ? styles.green
                                                              : ''
                                                      }> */}
                                                      {isOpen && _item ? (
                                                          _item
                                                      ) : (
                                                          <span style={{ color: '#273766' }}>--</span>
                                                      )}
                                                  </td>
                                              );
                                          }
                                      })}
                                  </tr>
                              ))
                            : blank.map((item, index) => {
                                  return (
                                      <tr key={index}>
                                          {item.map((_item, index) => {
                                              return (
                                                  <td key={index}>
                                                      <span style={{ color: '#273766' }}>--</span>
                                                  </td>
                                              );
                                          })}
                                      </tr>
                                  );
                              })}
                    </tbody>
                </table>
                <a className={styles.more} href={url} rel={rel} target="_blank">
                    更多&gt;&gt;
                </a>
            </div>
        );
    }
}

export default errorBoundary(Table);
